import { cdnFontsPath, cdnUrl } from '../';
const baseUrl = cdnUrl + cdnFontsPath;
export default `
	@font-face {
		font-family: 'Avenir Next';
		src: url('${baseUrl}/avenir-regular-lat-ext.woff');
		font-weight: 400;
	}

	@font-face {
		font-family: 'Avenir Next';
		src: url('${baseUrl}/avenir-medium-lat-ext.woff');
		font-weight: 500;
	}

	@font-face {
		font-family: 'Avenir Next';
		src: url('${baseUrl}/avenir-demi-lat-ext.woff');
		font-weight: 600;
	}

	@font-face {
		font-family: 'Avenir Next';
		src: url('${baseUrl}/avenir-bold-lat-ext.woff');
		font-weight: 700;
	}

	@font-face {
		font-family: 'DNV Display Light';
		src: url('${baseUrl}/dnv-display-light.woff');
		font-weight: 700;
	}

	@font-face {
		font-family: 'DNV Display';
		src: url('${baseUrl}/dnv-display-light.woff');
		font-weight: 200;
		font-style: normal;
	}

	@font-face {
		font-family: 'DNV Display';
		src: url('${baseUrl}/dnv-display-regular.woff');
		font-weight: bold;
	}

	@font-face {
		font-family: 'DNV Display';
		src: url('${baseUrl}/dnv-display-regular.woff');
		font-weight: 400;
		font-style: normal;
	}

	@font-face {
		font-family: 'DNV Display Medium';
		src: url('${baseUrl}/dnv-display-medium.woff');
		font-weight: bold;
	}

	@font-face {
		font-family: 'DNV Display';
		src: url('${baseUrl}/dnv-display-medium.woff');
		font-weight: 500;
		font-style: normal;
	}
`;
